import { Info } from "lucide-react";
import { cn } from "@/lib/utils";

interface AffiliateDisclosureProps {
  className?: string;
  compact?: boolean;
}

export function AffiliateDisclosure({ className, compact = false }: AffiliateDisclosureProps) {
  return (
    <aside
      role="note"
      aria-label="Oplysning om affiliate-links"
      className={cn(
        "flex items-start gap-2 rounded-md border border-border bg-muted/40 text-muted-foreground",
        compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm",
        className,
      )}
    >
      <Info className={cn("flex-shrink-0 mt-0.5", compact ? "h-3.5 w-3.5" : "h-4 w-4")} aria-hidden="true" />
      <p className="leading-relaxed">
        <strong className="font-semibold">Annonce / reklamelinks:</strong> Denne side kan indeholde affiliate-links.
        Det betyder, at Min Nye Elbil kan modtage kommission, hvis du klikker videre eller opretter dig via linket.
        Det påvirker ikke prisen for dig.
      </p>
    </aside>
  );
}
